import { BaseCheckoutPayFlowModule } from './BaseCheckoutPayFlowModule'

export const isCkoFlowModule = (paymentModule: unknown): paymentModule is BaseCheckoutPayFlowModule =>
  paymentModule instanceof BaseCheckoutPayFlowModule
